/* 针对不同功能不同情况显示与不显示处理 */
import { payTypeListClassify } from "@/config";
import { setStorage, getStorage } from '@/libs/utils'
import _ from 'lodash';
import { normalThirdSdkLogin } from '@/bridge/AppJsBridge'

const state = {
};

const mutations = {
};

const actions = {
  /**
   * @description 处理安卓三方登录渠道
   * @param {query} 浏览器参数
   */
  handleClientThirdPlatform({ dispatch, commit }, query) {
    let { thirdPlatform, huaweiframe } = query
    if (huaweiframe) thirdPlatform = huaweiframe;
    if (!thirdPlatform) return;
    setStorage('android_third_platform', thirdPlatform);
    const thirdKeys = Object.keys(payTypeListClassify.client)
    if (thirdKeys.includes(thirdPlatform) && thirdPlatform !== 'yyb' && !payTypeListClassify.special.includes(thirdPlatform)) {
      normalThirdSdkLogin(null)
      commit('user/CHANGE_STATE', {
        loginVisible: false
      }, { root: true })
    }
  },

  /**
   * @description 处理安卓三方登录渠道
   * @param {query} 浏览器参数
   */
     handleH5ThirdPlatform({ dispatch, commit }, query) {
      const { thirdPlatform } = query;
      if (!thirdPlatform) return;
      setStorage('android_third_platform', thirdPlatform);
      const thirdKeys = Object.keys(payTypeListClassify.h5)
      if (thirdKeys.includes(thirdPlatform) && thirdPlatform !== 'yyb') {
        normalThirdSdkLogin(null)
      }
    }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};